/**
 * External dependencies
 */

/**
 * Internal dependencies
 */
import { combineReducers } from 'redux';
import path from './path/reducer';

const route = combineReducers( {
    path,
} );

export default route;
